const tableDetails = {
  country: "Country",
  freePilot:"",
  companyDisplayName: "Company",
  numberOfNights: "Number of nights",
  license: "License",
  pricePerKm: "Price per km",
  street: "Street",
  licenses: "Licenses",
  startDateOffer: "Pilot available from",
  endDateOffer: "Offer end date",
  maxRadiusToStartInKm: "Maximum distance [km]",
  subscriptionEndDate: "Subscription (until)",
  driverLicenseType: "License type",
  vin: "VIN",
  myOffer: "My offer",
  statusAndDeadline: "Deadline",
  companyLowestOffer: "Lowest proposed offer",
  customName: "Custom name",
  created_at: "Registration date",
  technicalReviewExpirationDateFrom: "Technical inspection (from)",
  technicalReviewExpirationDateTo: "Technical inspection (to)",
  insurancePolicyWillRunOutSoon: "Policy expires soon",
  daysLeft: "Days left",
  note: "Note",
  userName: "Name",
  paidDate: "Payment date",
  isVerified: "Verified",
  bidThreshold: "",
  Nr: "Number",
  paid: "Paid",
  driverEmail: "Driver email",
  userId: "User ID",
  carStatus: "Status",
  modalAddWorker: "Add administrator",
  carRegistrationNumber: "Registration number",
  modalConfirmationWorkers: "Select an action to perform on the employee:",
  btnAccept: "Confirm",
  messageTitle: "Note",
  originalname: "File name",
  visible: "Visible publicly",
  action: "",
  email: "Email address",
  firstName: "First name",
  lastName: "Last name",
  role: "Role",
  admin: "Manager",
  worker: "Employee",
  owner: "Administrator",
  policyExpirationDate: "Policy expiration",
  carName: "Car name",
  administrator: "Manager",
  modalConfirmationUser: "Select an action to perform on the user:",
  modalConfirmationCompany: "Select an action to perform on the company:",
  modalConfirmationDepartment: "Select an action to perform:",
  modalConfirmationAuthorization: "Select an action to perform on the authorization:",
  modalConfirmationCars: "Select an action to perform on the car:",
  modalConfirmationDriver: "Select an action to perform on the driver:",
  nip: "Tax ID (NIP)",
  description: "Description",
  id: "ID",
  companyId: "ID",
  companyName: "Company name",
  companyCity: "City",
  companyAddress: "Address",
  companyZipCode: "Postal code",
  companyNip: "Tax ID",
  companyPhone: "Phone number",
  factoringCommission: "Factoring commission",
  userPhone: "Phone number",
  userCompany: "Role in company",
  undefined: "",
  startDate: "Start date",
  endDate: "End date",
  companyOwners: "Company owners",
  createdAt: "Created at",
  addresses: "Company addresses",
  departments: "Departments",
  warehouse: "Warehouse",
  driver: "Carrier",
  factory: "Manufacturer",
  templateName: "Template name",
  fullName: "Full name",
  documentNumber: "ID document number",
  name: "Name",
  policy_lasting: "Insurance valid until",
  surname: "Last name",
  address: "Address",
  city: "City",
  countryCode: "Country code",
  isAutomatic: "Automatic authorization",
  zipCode: "Postal code",
  phone: "Phone number",
  managers: "Managers",
  avatar: "Profile photo",
  ownerInCompanies: "Company owner:",
  status: "Status",
  type: "Type",
  departmentPhone: "Phone number",
  departmentAvatar: "Photo",
  department: "Department",
  trailerNumber: "Trailer number",
  semitrailerNumber: "Semi-trailer registration number",
  registrationNumber: "Reg. number",
  docType: "Document type",
  carType: "Vehicle type",
  carPart: "Part type",
  isDeleted: "Deleted",
  winningOffer: "Winning offer",
  gusConfirmed: "GUS compliance",
  hostIp: "Computer IP",
  subId: "XLplanner ID",
  incoming: "Incoming",
  carrier: "Carrier",
  monitaryDate: "Reservation date and time",
  warehouseMonitoryNoteId: "XLplanner order number",
  monitoryNoteNumberInWarehouse: "XLplanner order number",
  company: "Company",
  allowSms: "Allows SMS",
  phoneNumberVerified: "Phone number verified",
  companyWarehouseName: "Warehouse manager",
  driverFullName: "Driver",
  modifiedAt: "Confirmation date and time",
  lp: "Lp.",
  invoiceDate: "Invoice date",
  userDepartment: "Employee assigned to:",
  policyNumber: "Policy number",
  carInsurer: "Insurer",
  shortName: "Branch name",
  isMain: "Main branch:",
  carNumber: "Registration",
  dateStart: "Notification start",
  dateEnd: "Notification end",
  monitoryNoteNumber: "Notification number",
  driverName: "Driver",
  destination: "Warehouse",
  driverPhone: "Driver phone number",
  policyExpirationDateTo: "Insurance validity (to)",
  policyExpirationDateFrom: "Insurance validity (from)",
  factoring: "Factoring",
  editTableData: "Edit data",
  consignmentNumber: "Shipment number",
  cargos: "Cargos",
  length: "Number of members",
  orderNumber: "Order number",
  monitoryNoteStatus: "Time windows",
  cargoLoads: "Loading",
  cargoUnloads: "Unloading",
  companyLoader: "Client",
  verification: "Verification",
  isAccountVerified: "Email verification",
  startingPrice: "Starting price",
  deadline: "Deadline",
  remarks: "Additional info",
  currency: "Currency",
  participantsNumber: "Number of participants",
  lastAuctionPost: "Last listing date",
  numberOfCargo: "Cargo locations",
  numberOfLoads: "Start",
  numberOfUnoads: "Number of unloads",
  departmentLoader: "Issuing department",
  auctionType: "Auction type",
  defaultPaymentDeadlineDays: "Standard payment day",
  email_verified: "User confirmed account verification via email",
  email_unverified: "User has not confirmed account verification via email",
  firstDownloadedAt: "First downloaded",
  lng: "Longitude",
  lat: "Latitude",
  rampsCreated: "Ramps added",
  startPoint: "Start",
  endPoint: "Destination",
  numberOfUnloads: "Number of unloads",
  isOutside: "Is external",
  startHour: "Start time",
  endHour: "End time",
  date: "Date",
  driverDocument: "Driver document number",
  departmentsLength: "Members",
  download: "",
  auctionOffers: "Number of offers",
  startAucDate: "Start date",
  invoiceId: "Invoice number",
  surcharges: "Surcharges",
  auctionId: "Auction ID",
  lowestOffer: "Lowest offer",
  verificationTransferConfirmed: "Transfer confirmed",
  verificationTransferData: "Verification data from P24",
  departmentNameForDepartmentList: "Name",
  workerName: "First name",
  ramp: "Ramp",
  likes: "Positive ratings",
  dislikes: "Negative ratings",
  verificationTransferDate: "Created",
  policyStatus: "Policy status",
  isFinished: "Is completed",
  pilot: "Pilot",
  driverLicense: "License",
  lang:"Language",
};

export default tableDetails;
